import LightTooltip from './LightTooltip';

export default LightTooltip;